import { render, staticRenderFns } from "./agenda-screen.vue?vue&type=template&id=03ad2f00"
import script from "./agenda-screen.vue?vue&type=script&lang=ts"
export * from "./agenda-screen.vue?vue&type=script&lang=ts"
import style0 from "./agenda-screen.vue?vue&type=style&index=0&id=03ad2f00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports